import { render, staticRenderFns } from "./functionSetting.vue?vue&type=template&id=0330ecae&scoped=true"
import script from "./functionSetting.vue?vue&type=script&lang=js"
export * from "./functionSetting.vue?vue&type=script&lang=js"
import style0 from "./functionSetting.vue?vue&type=style&index=0&id=0330ecae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0330ecae",
  null
  
)

export default component.exports